
export class LexiStorage extends Storage {}
